import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

// Guards authenticated routes and enforces the forced-password-change flow.
export const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center text-body text-muted-foreground">
        Laden...
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Force password change before allowing access to the app.
  if (user.must_change_password && location.pathname !== "/wachtwoord-wijzigen") {
    return <Navigate to="/wachtwoord-wijzigen" replace />;
  }

  return children;
};
